import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";
import { DownloadByContent, ReactSelectOptions, mimeTypes } from "../utils";
import Select from "react-select";
import { DownloadFileAPI, GetPreSigendURL, RemoveFileAPI, UploadFileAPI, AfterUploadVideo } from '../../services';
import { useParams } from "react-router-dom";

const Attachment = ({types, info, onChange, fileKey, editable=true}) =>
{
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [file, SetFile] = useState(info);
	const [firstLoad, SetFirstLoad] = useState(true);
	const [progress, SetProgress] = useState(0);
	const [fileSRC, SetFileSRC] = useState('');
	const options = types ? ReactSelectOptions(types) : null;
	const {module} = useParams();
	const send_video = settings?.definitions?.modules?.[module]?.send_video ?? false;
	
	useEffect(() =>
	{
		if(firstLoad)
		{
			SetFirstLoad(true);
			if((!info.id || info.id === '') && info.data)
			{
				UploadFile(info.data);
			}
			else
			{
				GetFileContent(info.id);
			}
		}
	// eslint-disable-next-line
	}, []);

	useEffect(() =>
	{
		if(onChange && (file.id || file.deleted))
		{
			onChange(fileKey, file);
		}
	// eslint-disable-next-line
	}, [file]);

	const UploadFile = async (fileObject) =>
	{
		try
		{
			if(fileObject.type == "video/mp4" && send_video)
			{
				const data = { fileName:file.name }				
				const APIResponse = await GetPreSigendURL(data);
				const uploadResult = await fetch(APIResponse.url, {
					method: 'PUT',
					headers: {
						'Content-Type': file.type || 'application/octet-stream'
					},
					body: fileObject
				});
				if (uploadResult.ok) 
				{
					const videoData = { fileName:file.name, source_id : APIResponse.key, source : 'abramad'}
					const result = await AfterUploadVideo(videoData);
					if(result.id)
					{						
						SetFile({...file, id: result.id, url: result.location});
						GetFileContent(result.id);
					}
					else
					{
						SetFile({...file, deleted: true, data: {}});
					}
				} 
				else
				{
					throw new Error(language.ERROR.ERROR_IN_UPLOAD);
				}
				
			}
			else
			{
				let formData = new FormData();
				formData.append('file', fileObject);
				const APIResponse = await UploadFileAPI(formData, (progress) =>
				{
					SetProgress(progress);
				});				
				if(APIResponse.id)
				{
					SetFile({...file, id: APIResponse.id, url: APIResponse.location});
					GetFileContent(APIResponse.id);
				}
				else
				{
					SetFile({...file, deleted: true, data: {}});
				}
			}
		}
		catch (ex){ SetFile({...file, deleted: true, data: {}}); }
	}

	const GetFileContent = async (id) =>
	{
		const APIResponse = await DownloadFileAPI(id);
		if(APIResponse)
		{
			let extension = '';
			if(APIResponse.extension)
			{
				extension = APIResponse.extension;
			}
			else if(APIResponse.name && APIResponse.name.indexOf('.') > -1)
			{
				extension = APIResponse.name.split('.').slice(-1)[0];
			}
			const mime = mimeTypes[extension];
			let thumbnail = '';
			if(APIResponse.content && typeof mime !== 'undefined' && mime.indexOf('image') > -1)
			{
				thumbnail = 'data:'+mime+';base64,'+APIResponse.content;
			}
			else
			{
				switch (extension)
				{
					case 'xlsx': case 'xls': thumbnail = '/images/files/xlsx.png'; break;
					case 'docx': case 'doc': thumbnail = '/images/files/docx.png'; break;
					case 'zip': case 'rar': thumbnail = '/images/files/zip.png'; break;
					case 'txt': thumbnail = '/images/files/txt.png'; break;
					default: thumbnail = '/images/files/unknown.png'; break;
				}
			}
			SetFileSRC(thumbnail);
		}
		else
		{
			SetFileSRC('/images/files/unknown.png');
		}
	}

	const DownloadFile = async (id) =>
	{
		const APIResponse = await DownloadFileAPI(id);
		if (APIResponse)
		{
			if(APIResponse.content)
			{
				DownloadByContent(APIResponse.content, APIResponse.name);
			}
			else if(APIResponse.url)
			{
				const downloadLink = document.createElement("a");
				downloadLink.href = APIResponse.url;
				downloadLink.download = APIResponse.name;
				downloadLink.click();
			}
		}
	}

	const RemoveFile = async (id) =>
	{
		try
		{
			RemoveFileAPI(id).then(() => SetFile({...file, deleted: true, data: {}}));
		}
		catch (ex){ console.log(ex); }
	}
	const selectedType = file.template_type ? file.template_type : options.length === 1 ? options[0].value : '';
	return <>
	{file.deleted ? null : !file.id ?
	<div className='flex px-2 items-center w-full mt-3 first:mt-0'>
		<div className='min-w-[2rem]'><i className='fa fa-trash-alt cursor-pointer text-danger mx-auto fa-lg disabled'></i></div>
		<div className='w-full flex items-center justify-between grow max-w-[calc(100%-5rem)]'>
			<div dir='ltr' className='grow mx-2 h-2 bg-containerBG rounded'>
				<div className='h-2 bg-primary rounded progress' style={{'width': progress+'%'}}></div>
			</div>
		</div>
		<div className='min-w-[3rem] max-w-[3rem]'>
			<div className='w-12 rounded-xl flex justify-between items-center h-12'><i className='fa fa-spin fa-spinner mx-auto text-2xl'></i></div>
		</div>
	</div>
	:
	<div className='flex px-2 items-center w-full mt-3 first:mt-0'>
		<div className='min-w-[2rem]'>{!file.document_id ? <i className='fa fa-trash-alt cursor-pointer text-danger mx-auto fa-lg' onClick={() => RemoveFile(file.id)}></i> : <i className='fa fa-check-circle text-success mx-auto fa-lg'></i>}</div>
		<div className='w-full flex items-center justify-between grow max-w-[calc(100%-5rem)]'>
			<div dir='ltr' className='text-sm text-ellipsis whitespace-nowrap overflow-hidden grow ps-2 lg:ps-5'>
				<span title={file.document_name}>{file.document_name}</span>
			</div>
			<div className='w-1/3 min-w-[7.5rem]'>
				<div className="min-w-[7.5rem] max-w-[10rem]">
				{editable ?
				options ? <Select
					value={options.find((option) => option.value === selectedType)}
					onChange={(selectedOption) => {
						// If value is "0" (blank option), set to undefined instead
						const typeValue = (selectedOption && (selectedOption.value === "0" || selectedOption.value === 0)) ? undefined : (selectedOption ? selectedOption.value : undefined);
						SetFile({...file, type: typeValue});
					}}
					options={options}
					isClearable={false}
					placeholder={language.FILE_TYPE}
					menuPlacement='auto'
					className={settings.strings.dropdown_container}
					classNamePrefix={settings.strings.dropdown_prefix}
					isDisabled={false}
					isMulti={false}/>
				: <span className='text-xs'>{language.ATTACHMENT}</span>
				: <div>{file.template_type_label || language.ATTACHMENT}</div>}
				</div>
			</div>
		</div>
		<div className='ms-2 min-w-[3rem] max-w-[3rem]'>
			{fileSRC ? <img alt='FILE' src={fileSRC} className='rounded-xl cursor-pointer h-[3rem]' onClick={() => DownloadFile(file.id)}/>
			: <div className='flex items-center h-12'><i className='fa fa-spin fa-spinner mx-auto text-2xl'></i></div>}
		</div>
	</div>
	}
	</>
}

export default Attachment;